import config from './serverVars'
const dev = {
    log : (...args) => {
        if(!(config.hideLogs.indexOf(config.env) + 1))
            console.log(...args)
    }
}

export default dev